"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const useOsmosysContext_1 = require("../hooks/useOsmosysContext");
const react_if_1 = require("react-if");
exports.BotLandingPage = () => {
    const { location } = use_react_router_1.default();
    const { isLoggedIn } = useOsmosysContext_1.useOsmosysContext();
    return (react_1.default.createElement("div", { className: "text-center" },
        react_1.default.createElement(react_2.OsmosysLogo, { width: "5em", height: "5em" }),
        react_1.default.createElement("h2", { className: "mt-1 mb-3" }, "Osmosys Bot"),
        react_1.default.createElement(react_2.OsmosysDiv, { flexRowCentered: true },
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "lead", style: { maxWidth: 460 } }, "Chat with Osmosys Bot powered by the insights of newsletter expert Jacque Boltik, the Newsletter Guide, Yellow Brim, and the creators of Osmosys."))),
        react_1.default.createElement("br", null),
        react_1.default.createElement(react_if_1.If, { condition: !isLoggedIn },
            react_1.default.createElement(react_if_1.Then, null,
                react_1.default.createElement(react_2.OsmosysButton, { osysName: "BotLandingPage.button", osysIcon: "arrowRight", iconPosition: "right", className: "font-weight-bold", to: location.pathname.replace(/\/$/, '') + '/signup' }, "Get started"),
                react_1.default.createElement(react_2.OsmosysDiv, { flexRowCentered: true },
                    react_1.default.createElement("div", { className: "mt-2" },
                        react_1.default.createElement("p", { className: "text-muted small", style: { maxWidth: 360 } }, "Osmosys Bot is free to use. No credit card required.")))),
            react_1.default.createElement(react_if_1.Else, null,
                react_1.default.createElement(react_2.OsmosysDiv, { flexRowCentered: true },
                    react_1.default.createElement("div", { className: "mt-2" },
                        react_1.default.createElement("p", { className: "text-muted text-center small", style: { maxWidth: 360 } }, "Osmosys Bot is coming soon for Osmosys workspace users!")))))));
};
exports.default = exports.BotLandingPage;
//# sourceMappingURL=BotLandingPage.js.map